let cardProdutSlider = new Swiper('.card-product-slider', {
    loop: true,
    // nextButton: '.card-product-slider .swiper-button-next',
    // prevButton: '.card-product-slider .swiper-button-prev',
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1,
    // breakpoints: {
    //     1920: {
    //         slidesPerView: 3,
    //         spaceBetween: 30
    //     },
    //     1028: {
    //         slidesPerView: 2,
    //         spaceBetween: 30
    //     },
    //     480: {
    //         slidesPerView: 1,
    //         spaceBetween: 10
    //     }
    // }
});

$( document ).ready(function() {
    $(".header__icon--menu").click(function(){
      $("body").toggleClass("menu-open");
    });
    //  $(".angle-button").click(function(){
    //   $("body").toggleClass("sub-menu-open");
    // });
  
  // Open submenu First to second
    $("#menu__drawer .menu__item .menu__item-item .angle-button").click(function(){
      $('body').addClass('sub-menu-open');
      $('#menu__drawer').addClass('menu--horizontal--openSubMenu');
      $(this).parents("li").addClass('openSubMenu showSubmenu');
    });

  // Open submenu second to third
    $("#menu__drawer .menu__item .submenu .angle-button").click(function() {
      $('body').addClass('sub-menu-open');
      $('#menu__drawer').addClass('menu--horizontal--openSubMenuThird');
      $(this).parents('li').addClass('submenuOpen showSubmenu');
    });
  // Back menu 
    $("#menu__drawer .menu__item .submenu .back-2").click(function(){
      $('body').removeClass('sub-menu-open');
      $('#menu__drawer').removeClass('menu--horizontal--openSubMenu menu--horizontal--openSubMenuThird');
      $(this).parents('li.openSubMenu').removeClass('openSubMenu showSubmenu');
    });

    $("#menu__drawer .menu__item .submenu .thirdmenu .back-3").click(function(){
      $('#menu__drawer').removeClass('menu--horizontal--openSubMenuThird');
      $(this).parent().parent().parent().removeClass('submenuOpen showSubmenu');
    });
// Close menu
    $('#menu__drawer .close').click(function() {
      $('body').removeClass('menu-open sub-menu-open');
      $('#menu__drawer').removeClass('menu--horizontal--openSubMenu menu--horizontal--openSubMenuThird');
      $('#menu__drawer li').removeClass('submenuOpen openSubMenu showSubmenu')
    });
  
});